import { type KeystoneReferral } from "data/keystone-api-mapping";
import { checkForNaStringValue } from "utils";

/** Heading for eligible / ineligible write-out cards (strip prefix; grouped → “Multiple issues”). */
export function getReferralWriteOutCardHeading(
  referral: KeystoneReferral,
): string | null {
  const { issueStatement, groupedIssueStatements } = referral;
  let raw = issueStatement?.replace(/^.*? - /, "") ?? "";
  if (groupedIssueStatements?.length) {
    raw = "Multiple issues";
  }
  return checkForNaStringValue(raw);
}

export function getReferralReasonings(referral: KeystoneReferral): string[] {
  const { groupedReasonings, reasoning } = referral;
  const reasoningDisplay = checkForNaStringValue(reasoning ?? "");
  if (groupedReasonings?.length) {
    return groupedReasonings;
  }
  if (reasoningDisplay) {
    return [reasoningDisplay];
  }
  return [];
}

/**
 * Category and/or location under the write-out card title.
 * Both → `category • location`; one present → that value only; neither → empty string.
 */
export function formatReferralWriteOutCardSubheading(
  referral: KeystoneReferral,
): string {
  const categoryDisplay = checkForNaStringValue(referral.category ?? "");
  const locationDisplay = checkForNaStringValue(referral.locationDetail ?? "");
  if (categoryDisplay && locationDisplay) {
    return `${categoryDisplay} • ${locationDisplay}`;
  }
  if (categoryDisplay) {
    return categoryDisplay;
  }
  if (locationDisplay) {
    return locationDisplay;
  }
  return "";
}
